/* =====================================================================
   KEYBOARD MAPPING
   Letters use the physical key (`code`), so they sit in the same place on
   every layout; digits use the typed character (`key`), so the number row
   and the numpad both pick materials.
   ===================================================================== */

export type Mode = "place" | "grab" | "push" | "remove";

export type KeyAction =
  | { type: "help" }
  | { type: "debug" }
  | { type: "material"; index: number }
  | { type: "rotate"; dir: 1 | -1 }
  | { type: "primary" }
  | { type: "mode"; mode: Mode }
  | { type: "up" } // lift the held block, or raise the drop height
  | { type: "down" };

const BY_CODE: Record<string, KeyAction> = {
  KeyH: { type: "help" },
  Backquote: { type: "debug" },
  KeyQ: { type: "rotate", dir: -1 },
  KeyE: { type: "rotate", dir: 1 },
  Space: { type: "primary" },
  KeyB: { type: "mode", mode: "place" },
  KeyG: { type: "mode", mode: "grab" },
  KeyP: { type: "mode", mode: "push" },
  KeyX: { type: "mode", mode: "remove" },
  KeyR: { type: "up" },
  KeyF: { type: "down" },
};

/** The game action for a key press, or null when the key does nothing. */
export function keyAction(code: string, key: string, materials: number): KeyAction | null {
  const n = parseInt(key, 10);
  if (n >= 1 && n <= materials) return { type: "material", index: n - 1 };
  return BY_CODE[code] ?? null;
}

// prettier-ignore
const CAM_KEYS = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'KeyI', 'KeyJ', 'KeyK', 'KeyL', 'Equal', 'Minus', 'NumpadAdd', 'NumpadSubtract'];

/** Keys that move the camera while held. */
export function isCameraKey(code: string): boolean {
  return CAM_KEYS.includes(code);
}
